import { SxStyles } from '../../types';
import theme from '../../theme';
import { getResponsiveSize } from '../../utils';

export const ErrorDialogStyle: SxStyles = {
  errorModal: {
    '&.error-modal .modal-wrapper': {
      maxWidth: 'calc(100vw - 32px)',
      overflow: 'hidden',
    },
    [theme.breakpoints.media?.tablet!]: {
      '&.error-modal .modal-wrapper': {},
    },
  },
  container: {
    p: getResponsiveSize(16),
    backgroundColor: '#FCFCFC',
  },
  titleText: {
    mb: getResponsiveSize(16),
    fontWeight: 700,
  },
  messageText: {
    color: theme.palette.neutral?.grey70,
  },
  errorCodeBlock: {
    mt: getResponsiveSize(8),
    mb: 0,
  },
  actions: {
    mt: getResponsiveSize(16),
    display: 'flex',
    justifyContent: 'flex-end',
  },
};
